import { useState, useEffect, useRef } from 'react'
import { IPressReleaseSortTypes } from '@interfaces'

export const usePagination = (
  collection = [],
  limit = 8,
  fakeLoadingMs = 1000,
  /**
   * activeSortType is only use on press release page
   */
  activeSortType: IPressReleaseSortTypes = 'displayDate-asc'
) => {
  const containerRef = useRef(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPage, setTotalPage] = useState(
    Math.max(1, Math.ceil(collection.length / limit))
  )
  const [paginatedData, setPaginatedData] = useState(() =>
    collection.slice(0, limit)
  )
  const [isLoading, setLoading] = useState(false)
  const startLoading = () => setLoading(true)
  const stopLoading = () => setLoading(false)

  useEffect(() => {
    const nextTotalPage = Math.max(1, Math.ceil(collection.length / limit))
    setTotalPage(nextTotalPage)

    const safeCurrentPage = Math.min(currentPage, nextTotalPage)
    if (safeCurrentPage !== currentPage) {
      setCurrentPage(safeCurrentPage)
      return
    }

    const startIndex = limit * (safeCurrentPage - 1)
    const endIndex = limit * safeCurrentPage
    setPaginatedData(collection.slice(startIndex, endIndex))
  }, [collection, currentPage, limit, activeSortType])

  useEffect(() => {
    setCurrentPage(1)
  }, [collection, activeSortType])

  // Triggers fetch for new page
  const handlePagination = (page: number) => {
    startLoading()
    containerRef.current?.scrollIntoView()
    setTimeout(() => {
      stopLoading()
      setCurrentPage(page)
    }, fakeLoadingMs)
  }

  return {
    handlePagination,
    isLoading,
    containerRef,
    currentPage,
    totalPage,
    paginatedData,
  }
}
